import { Box, Button, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { ReactComponent as NoLinksSvg } from "@assets/images/NoPicsSvg.svg";

import SocialLinksCard from "./SocialLinksCard";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { scroller } from "react-scroll";
import { useEffect, useRef } from "react";

const AddSocialLinksForm = ({
  form,
  push,
  remove,
  name = "external_links",
}) => {
  const lastAddedIndex = useRef(null);

  const handleAddLink = () => {
    const newIndex = form.values[name].length;
    push({
      title: name !== "business_link" ? "" : undefined,
      link: "",
      is_cta_enabled: true,
      icon: "",
    });
    lastAddedIndex.current = newIndex;
  };

  useEffect(() => {
    if (lastAddedIndex.current !== null) {
      scroller.scrollTo(`link-${lastAddedIndex.current}`, {
        duration: 500,
        smooth: true,
        containerId: "links-container",
      });
      lastAddedIndex.current = null;
    }
  }, [form.values[name]?.length]);

  const handleRemoveLink = (index) => {
    remove(index);
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "20px",
        width: "100%",
        height: "calc(100% - 20px)",
        mt: "20px",
        pb: "20px",
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: "flex",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: "5px",
            alignItems: "flex-start",
            flexDirection: "column",
          }}
        >
          <Typography
            sx={{
              color: "#0F0F0F",
              fontSize: "16px",
              fontWeight: "500",
              lineHeight: "20px",
              fontFamily: "DM Sans",
            }}
          >
            Add Links
          </Typography>

          <Typography
            sx={{
              color: "#565556",
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "DM Sans",
            }}
          >
            Drag and place the link in the desired order.
          </Typography>
        </Box>

        <Button
          onClick={handleAddLink}
          startIcon={<AddIcon />}
          sx={{
            color: "#9B5AF8",
            textTransform: "capitalize",
            fontSize: "16px",
            fontWeight: "500",
            background: "white",
            border: "1px solid #9B5AF8",
            fontFamily: "DM Sans",
            "&:hover": {
              background: "#9B5AF8",
              color: "white",
              border: "1px solid transparent",
            },
          }}
          variant="outlined"
        >
          Add Link
        </Button>
      </Box>

      {!form.values[name]?.length && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
            background: "#F4F4F6",
            borderRadius: "8px",
            flex: 1,
          }}
        >
          <NoLinksSvg />
          <Typography
            sx={{
              color: "#626364",
              fontSize: "16px",
              fontWeight: "600",
              lineHeight: "20px",
              fontFamily: "DM Sans",
            }}
          >
            No links added yet
          </Typography>
        </Box>
      )}

      <DndProvider backend={HTML5Backend}>
        <Box
          id="links-container"
          sx={{
            maxHeight: "calc(100vh - 300px)",
            overflowY: "auto",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          {form.values[name]?.length > 0 &&
            form.values[name].map((link, index) => (
              <SocialLinksCard
                key={index}
                link={link}
                index={index}
                name={name}
                handleRemoveLink={() => handleRemoveLink(index)}
              />
            ))}
        </Box>
      </DndProvider>
    </Box>
  );
};

export default AddSocialLinksForm;
